var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var stable = require('stable');
var slugify = require('../utils/slugify.js');

function RankingsFeatures(el) {
  var $el = $(el),
      $companyData = '/wp-content/themes/justcapital/assets/data/companies.json',
      $companies,
      $select = $el.find('.custom-select'),
      $rankings = $el.find('.mini-rankings');

  $.getJSON($companyData, function(data) {
    $companies = data;
    topRanked();
  });

  // Clicks within the dropdown won't bubble up past the dropdown element
  $('.custom-select').click(function(e){
    e.stopPropagation();
  });

  $select.on('click', 'p', function() {
    // Expand dropdown options
    $select.children('ul').hide();
    $(this).next().show();
  }).on('click', 'a', function(e) {
    e.preventDefault();
    // When an option is selected, change the selected value
    var $dropdown = $(this).closest('.custom-select'),
        $dropdownLabel = $dropdown.find('p'),
        $dropdownValue = $(this).attr('data-val');
    $dropdownLabel.attr('data-val', $dropdownValue).text($(this).text());
    $dropdown.children('ul').hide();
    topRanked($dropdownValue);
  });

  function topRanked(view) {
    function sort(x,y) {
      return y.scores[view].overall - x.scores[view].overall;
    }
    var $rankedCompanies = view ? stable($companies, sort) : $companies,
        $items = '',
        $prevIssueScore = '',
        $tieFix = [],
        $tieRank = null;
    for (var i = 0; i < 7; i++) {
      var $company = $rankedCompanies[i],
          $rank = parseInt($company.rank.overall),
          $topSeal = '<span class="seal"></span>';
      if (view) {
        var $index = i + 1,
            $overall_rank = $company.rank.overall ? parseInt($company.rank.overall) : null,
            $topSeal = ($overall_rank && $overall_rank <= 100) ? '<span class="seal"></span>' : '';

        $issueScore = $company.scores[view].overall;
        if ($issueScore === $prevIssueScore) {
          if (!$tieRank) $tieRank = $prevIssueScore ? $index - 1 : $index;
          $tieFix.push($company.ticker);
          $index = $tieRank;
        } else {
          $tieRank = null;
        }
        $prevIssueScore = $issueScore;
        $rank = $index;
      }
      $items += '<li data-co="' + $company.ticker + '"><a href="/companies/' + slugify($company.name) + '"><p class="rankings__left-col"><span class="rank">' + $rank + '</span></p><p class="rankings__logo"><img src="/wp-content/themes/justcapital/assets/img/company-logos/' + $company.ticker + '.png" alt="" /></p><div class="rankings__company"><p>' + $company.name + '</p><p>' + $company.industry + '</p></div><p class="company-seal">' + $topSeal + '</p></a></li>';
    }
    $rankings.removeClass('visible').empty().append($items).ready(function() {
      for (var t = 0; t < $tieFix.length; t++) {
        var $firstTied = $rankings.find('li[data-co="' + $tieFix[t] + '"]').prev();
        $firstTied.find('.rankings__left-col').prepend('<span class="rank--label">Tied</span>');
        if (t === $tieFix.length - 1) $rankings.find('li[data-co="' + $tieFix[t] + '"] .rankings__left-col').prepend('<span class="rank--label">Tied</span>');
      }
      $rankings.addClass('visible');
    });
  }

}

module.exports = RankingsFeatures;
